<template>
  <!-- Modal -->
  <div class="modal fade" id="ArchiveInventoryAddModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">追加</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>JANコード</th>
                <th>型番</th>
                <th>個数</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td><input v-model="janCode" class="form-control form-control-sm" type="text"></td>
                <td><input v-model="typeNumber" class="form-control form-control-sm" type="text"></td>
                <td><input v-model="amount" min-value="0" class="form-control form-control-sm" type="text"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button ref="closeAddInventory" type="button" class="btn btn-secondary" data-dismiss="modal" @click="clearFields()">閉じる</button>
          <button type="button" class="btn btn-primary" @click="addInventory()">追加</button>
        </div>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'ArchiveInventoryAddModal',
  components: {
    VueElementLoading
  },
  props: {},
  data () {
    return {
      isLoading: false,
      janCode: '',
      typeNumber: '',
      amount: 0,
      stockStatus: 0
    }
  },
  created: async function () {

  },
  methods: {
    async addInventory () {
      if (this.janCode === '') {
        this.$toastr.warning('JANコードをご入力ください')
        return
      }

      if (this.typeNumber === '') {
        this.$toastr.warning('型番をご入力ください')
        return
      }

      if (this.amount <= 0) {
        this.$toastr.warning('個数を半角数字でご入力ください')
        return
      }

      this.isLoading = true

      this.addParams = {
        jan_code: this.janCode,
        type_number: this.typeNumber,
        amount: this.amount,
        in_stock_status: this.stockStatus
      }

      try {
        this.$http.post(this.$api_url.inventory_add, this.addParams).then(result => {
          if (result.data && result.data.status === true) {
            this.warehouses = result.data.data
            this.$toastr.success('追加が完了しました')
            const btn = this.$refs.closeAddInventory
            btn.click()
          } else if (result.data && result.data.message) {
            this.$toastr.error(result.data.message, 'エラー')
          } else {
            this.$toastr.error(result.data, 'エラー')
          }
        })
      } catch (error) {
        console.log('error: ', error)
        this.$toastr.error('エラーが発生しました。ご確認後再試行してください。', 'エラー')
      }
      setTimeout(() => { this.isLoading = false }, 1000)
    },

    clearFields () {
      this.janCode = ''
      this.typeNumber = ''
      this.amount = 0
    }
  }
}
</script>
